var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('sf-data-table',{attrs:{"paging":"","columns":_vm.dayCols,"rows":_vm.resultList,"pageUnit":_vm.groups.pageUnit,"excel":_vm.isButton_(_vm.scrId, 'EX'),"totalSize":_vm.groups.totalSize,"currentPage":_vm.groups.currentPage,"pageArray":_vm.screen.pageArray},on:{"changedPage":_vm.changedPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }